export enum InvestmentSecurityType {
  Equity = 1,
  Debt = 2,
  DirectOwnership = 3

  /* Old values:

  CommonEquity = 1,
  Debt = 2,
  Mezzanine = 3,
  SeniorDebt = 4,
  PreferredEquity = 5

  */

  // if changing or adding values, updadte all other methods (toString, toList).
}

// tslint:disable-next-line:no-namespace
export namespace InvestmentSecurityType {
  export function toString(investmentSecurityType: InvestmentSecurityType): string {
    switch (investmentSecurityType) {
      case InvestmentSecurityType.Equity:
        return 'Equity Investment';
      case InvestmentSecurityType.Debt:
        return 'Debt Investment';
      case InvestmentSecurityType.DirectOwnership:
        return 'Direct Ownership';
      default:
        return null;
    }
  }

  export function optionsForAssetFundraising() {
    return [InvestmentSecurityType.Equity, InvestmentSecurityType.Debt, InvestmentSecurityType.DirectOwnership];
  }

  export function optionsForFundFundraising() {
    return [InvestmentSecurityType.Equity];
  }


  export function parse(investmentSecurityTypeStr: string): InvestmentSecurityType {
    return InvestmentSecurityType[investmentSecurityTypeStr];
  }
}

export default InvestmentSecurityType;
